import { render } from "./MenuAyudaResumen.vue?vue&type=template&id=0ed94650"
import script from "./MenuAyudaResumen.vue?vue&type=script&lang=js"
export * from "./MenuAyudaResumen.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__